var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadPdfHereIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7763 11.0398L21.7715 11.0208L19.1022 4.23805C18.9832 3.85502 18.6287 3.59094 18.2267 3.59094H7.40659C7.00215 3.59094 6.64291 3.85978 6.52871 4.24757L4.03305 10.9613L4.02592 10.978L4.02116 10.997C3.99023 11.1136 3.98071 11.2326 3.99737 11.3491C3.99499 11.3872 3.99261 11.4253 3.99261 11.4633V20.1684C3.99324 20.5518 4.14584 20.9194 4.41697 21.1905C4.6881 21.4616 5.05565 21.6142 5.43909 21.6149H20.3607C21.1577 21.6149 21.8072 20.9654 21.8096 20.1684V11.4633C21.8096 11.4324 21.8096 11.4015 21.8072 11.3753C21.8167 11.2587 21.8072 11.1469 21.7763 11.0398ZM14.7389 10.0168L14.7318 10.3904C14.7128 11.4586 13.9752 12.1771 12.8975 12.1771C12.3717 12.1771 11.9197 12.0081 11.5938 11.687C11.2678 11.3658 11.0894 10.9185 11.0799 10.3904L11.0728 10.0168H6.17661L8.06798 5.41808H17.5653L19.509 10.0168H14.7389ZM5.81736 11.844H9.55966C10.1378 13.2024 11.3678 14.0042 12.8999 14.0042C13.7016 14.0042 14.4463 13.7806 15.0482 13.3571C15.5764 12.9859 15.9879 12.4673 16.2544 11.844H19.9777V19.7877H5.81736V11.844Z",
    fill: "#605BFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadPdfHereIcon);
export default __webpack_public_path__ + "static/media/UploadPdfHereIcon.53351966797d0ae35880afbc8120dd0b.svg";
export { ForwardRef as ReactComponent };